"use client";
import { Suspense } from "react";
import { Button } from "../ui/button";
import { client } from "@/lib/auth-client";
import { useTranslations } from "next-intl";

export const ButtonCloseSession = () => {
  const t = useTranslations("Index");
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Button
        size={"lg"}
        className="text-xl"
        variant={"link"}
        onClick={async () => {
          await client.signOut();
          window.location.reload();
        }}
      >
        {t("signOut")}
      </Button>
    </Suspense>
  );
};
